module.exports = __webpack_public_path__ + "b6d50fb55e47f033d8be4ca235e1969e.png";